import { observer } from 'mobx-react-lite'
import React from 'react'

import { Button, createStyles } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useStores } from '@trivie/core'
import { color } from '@trivie/ui-web/theme/color'
import { Text } from '@trivie/ui-web/components/text'

import magic from './magic.png'
const logo = require('../../../assets/logo.png')

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      '&.MuiButton-root:hover': {
        backgroundColor: 'transparent',
      },
      height: 20,
    },
  }),
)

export const MagicLinkErrorScreen: React.FunctionComponent = observer(() => {
  const { userStore } = useStores()
  const { sendMagicLink, email } = userStore

  const sendAgain = () => {
    sendMagicLink(email)
  }

  const classes = useStyles()

  return (
    <div style={ROOT}>
      <img src={logo} style={{ height: 60, margin: 20 }} />
      <div style={LEFT_CONTAINER}>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div>
            <div style={{ flexDirection: 'column', display: 'flex' }}>
              <div style={{ flexDirection: 'column' }}>
                <h2 style={{ fontSize: 24, marginTop: -6.5 }}>Unauthorized</h2>

                <div style={{ flexDirection: 'row', display: 'flex' }}>
                  <Text
                    style={{
                      marginBottom: 60,
                      color: color.shade50,
                      fontSize: 16,
                    }}
                    variant="titleMedium"
                    tx="Onboarding.Login.expiredMagicLink"
                  />
                </div>
              </div>

              <>
                <div
                  style={{
                    flexDirection: 'row',
                    display: 'flex',
                    marginTop: -35,
                    marginBottom: 35,
                  }}
                >
                  <Button
                    role="Button"
                    aria-label="Send Magic Link Again"
                    onClick={sendAgain}
                    classes={classes}
                    style={{ width: 100, padding: 0 }}
                  >
                    <Text
                      variant="titleMedium"
                      style={{
                        position: 'absolute',
                        color: color.blue,
                        textDecoration: 'underline',
                      }}
                      tx="Onboarding.Login.sendItAgain"
                    />
                  </Button>
                </div>
                <div style={{ flexDirection: 'row', display: 'flex' }}>
                  <Text
                    variant="titleMedium"
                    style={{
                      color: color.shade50,
                    }}
                    text="Need help? Reach out to&nbsp;"
                  />
                  <a href={`mailto:${process.env.REACT_APP_SUPPORT}`}>
                    <Text
                      variant="titleMedium"
                      style={{
                        color: color.blue,
                        textDecoration: 'underline',
                      }}
                      text={process.env.REACT_APP_SUPPORT}
                    />
                  </a>
                  <Text
                    variant="titleMedium"
                    style={{
                      color: color.shade50,
                    }}
                    text="&nbsp;to get in touch with us."
                  />
                </div>
              </>
            </div>
          </div>
        </div>
      </div>
      <div style={RIGHT_CONTAINER}>
        <img style={{ alignSelf: 'center' }} alt="blobs" height={399} width={415} src={magic} />
      </div>
    </div>
  )
})

const ROOT: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  backgroundColor: '#fff',
}
const LEFT_CONTAINER: React.CSSProperties = {
  width: '71%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  backgroundColor: '#fff',
}
const RIGHT_CONTAINER: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  width: '29%',
  backgroundColor: '#F6F8FB',
  justifyContent: 'center',
}
